export const normalizeImportRubricResponse = response => Object.values(response).map(question => question.split('\n'))

export const normalizeBuildQuestionDefinitionsResponse = response =>
    Object.values(response).map(question => ({
        id: Math.floor(Math.random() * 1000000),
        matchingQuestionId: question.matching_question_id,
        name: question.name,
        content: question.text,
        wordsLimit: question.word_count_limit,
        weight: question.weight,
        gradingReferenceContent: question.grading_reference_content,
        categories: question.categories.map(category => ({
            id: Math.floor(Math.random() * 1000000),
            name: category.name,
            feedback: category.feedback,
            grade: category.grade,
        })),
        unmatched: question.extra_content,
        summary: question.question_summary,
    }))
